import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router);


var path_product, path_solution, path_news, path_aboutUs;
if(path_product = `/digitalProducts/`){
  path_product = `/`;
}
if(path_news = `/news/`){
  path_news = `/`;
}
if(path_solution = `/solution/`){
  path_solution = `/`;
}
if(path_aboutUs = `/aboutUs/`){
  path_aboutUs = `/`;
}

export default new Router({
  routes: [
    {
      path: '/',
      redirect: '/home'
    },
    {
      path: '/home',  //首页
      name: 'home',
      component: resolve=>require(['@/components/home'],resolve)
    },
    {
      path: `${path_product}main`,  //数字产品
      name: 'product',
      component: resolve=>require(['@/components/product/main'],resolve),
      children: [
        {
          path: `${path_product}memberButler`,
          name: 'memberButler',
          component: resolve=>require(['@/components/product/memberButler'],resolve)
        },
        {
          path: `${path_product}expertTeam`,
          name: 'expertTeam',
          component: resolve=>require(['@/components/product/expertTeam'],resolve)
        },
        {
          path: `${path_product}familyDoctor`,
          name: 'familyDoctor',
          component: resolve=>require(['@/components/product/familyDoctor'],resolve)
        },
        {
          path: `${path_product}coreProduct`,
          name: 'coreProduct',
          component: resolve=>require(['@/components/product/coreProduct'],resolve)
        },
        {
          path: `${path_product}doctorApp`,
          name: 'doctorApp',
          component: resolve=>require(['@/components/product/doctorApp'],resolve)
        }
      ]
    },
    {
      path: '/solution',  //解决方案
      name: 'solution',
      component: resolve=>require(['@/components/solution/main'],resolve),
      children: [
        {
          path: `${path_solution}solutionIntro`,
          name: 'solutionIntro',
          component: resolve=>require(['@/components/solution/solutionIntro'],resolve)
        },
        {
          path: `${path_solution}solutionItem`,
          name: 'solutionItem',
          component: resolve=>require(['@/components/solution/solutionItem'],resolve)
        },
        {
          path: `${path_solution}solutionCase`,
          name: 'solutionCase',
          component: resolve=>require(['@/components/solution/solutionCase'],resolve)
        },
        {
          path: `${path_solution}caseDetails/:id`,
          name: 'caseDetails',
          component: resolve=>require(['@/components/solution/caseDetails'],resolve)
        }
      ]
    },
    {
      path: `${path_news}main`,  //资讯动态
      name: 'news',
      component: resolve=>require(['@/components/news/main'],resolve),
      children: [
        {
          path: `${path_news}company`,
          name: 'companyNews',
          component: resolve=>require(['@/components/news/company'],resolve)
        },
        {
          path: `${path_news}companyNewDetails/:id`,
          name: 'companyNewDetails',
          component: resolve=>require(['@/components/news/companyNewDetails'],resolve)
        },
        {
          path: `${path_news}industry`,
          name: 'industryNews',
          component: resolve=>require(['@/components/news/industry'],resolve)
        },
        {
          path: `${path_news}industryNewDetails/:id`,
          name: 'industryNewDetails',
          component: resolve=>require(['@/components/news/industryNewDetails'],resolve)
        }
      ]
    },
    {
      path: '/joinUs',  //加入我们
      name: 'joinUs',
      component: resolve=>require(['@/components/joinUs'],resolve)
    },
    {
      path: `${path_aboutUs}main`,  //关于我们
      name: 'aboutUs',
      component: resolve=>require(['@/components/aboutUs/main'],resolve),
      children: [
        {
          path: `${path_aboutUs}companyIntro`,
          name: 'companyIntro',
          component: resolve=>require(['@/components/aboutUs/companyIntro'],resolve)
        },
        {
          path: `${path_aboutUs}cooperation`,
          name: 'cooperation',
          component: resolve=>require(['@/components/aboutUs/cooperation'],resolve)
        },
        {
          path: `${path_aboutUs}scientist`,
          name: 'scientist',
          component: resolve=>require(['@/components/aboutUs/scientist'],resolve)
        },
        {
          path: `${path_aboutUs}contactUs`,
          name: 'contactUs',
          component: resolve=>require(['@/components/aboutUs/contactUs'],resolve)
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js